import DrawerSoft10 from './drawer-icon/soft_10.svg';
import DrawerSoft25 from './drawer-icon/soft_25.svg';
import DrawerSoft50 from './drawer-icon/soft_50.svg';
import DrawerEMPTY from './drawer-icon/empty.svg';

import { EMPTY_EFFECT } from '../../preset-util/base-preset-util';

import SoftEdgeVariant1ptFill from '@tencent/docs-design-resources/icon/desktop/svg/soft_edge_variant_1pt_fill_44.svg';
import SoftEdgeVariant2pt5Fill from '@tencent/docs-design-resources/icon/desktop/svg/soft_edge_variant_2pt5_fill_44.svg';
import SoftEdgeVariant5Fill from '@tencent/docs-design-resources/icon/desktop/svg/soft_edge_variant_5_fill_44.svg';
import SoftEdgeVariant10Fill from '@tencent/docs-design-resources/icon/desktop/svg/soft_edge_variant_10_fill_44.svg';
import SoftEdgeVariant25Fill from '@tencent/docs-design-resources/icon/desktop/svg/soft_edge_variant_25_fill_44.svg';
import SoftEdgeVariant50Fill from '@tencent/docs-design-resources/icon/desktop/svg/soft_edge_variant_50_fill_44.svg';
import NoEffectFill from '@tencent/docs-design-resources/icon/desktop/svg/no_effect_fill_44.svg';

import ShapeSoftEdgeVariant1ptFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_softenededgevariant_1pt_44.svg';
import ShapeSoftEdgeVariant2pt5Fill from '@tencent/docs-design-resources/icon/desktop/svg/shape_softenededgevariant_2point5pt_44.svg';
import ShapeSoftEdgeVariant5Fill from '@tencent/docs-design-resources/icon/desktop/svg/shape_softenededgevariant_5pt_44.svg';
import ShapeSoftEdgeVariant10Fill from '@tencent/docs-design-resources/icon/desktop/svg/shape_softenededgevariant_10pt_44.svg';
import ShapeSoftEdgeVariant25Fill from '@tencent/docs-design-resources/icon/desktop/svg/shape_softenededgevariant_25pt_44.svg';
import ShapeSoftEdgeVariant50Fill from '@tencent/docs-design-resources/icon/desktop/svg/shape_softenededgevariant_50pt_44.svg';
import ShapeNoEffectFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_noeffect_44.svg';

export {
    DrawerSoft10,
    DrawerSoft25,
    DrawerSoft50,
    DrawerEMPTY,
};

export const IMAGE_PRESET_ICONS = {
    [EMPTY_EFFECT]: NoEffectFill,
    'soft-1': SoftEdgeVariant1ptFill,
    'soft-2.5': SoftEdgeVariant2pt5Fill,
    'soft-5': SoftEdgeVariant5Fill,
    'soft-10': SoftEdgeVariant10Fill,
    'soft-25': SoftEdgeVariant25Fill,
    'soft-50': SoftEdgeVariant50Fill,
};

export const SHAPE_PRESET_ICONS = {
    [EMPTY_EFFECT]: ShapeNoEffectFill,
    'soft-1': ShapeSoftEdgeVariant1ptFill,
    'soft-2.5': ShapeSoftEdgeVariant2pt5Fill,
    'soft-5': ShapeSoftEdgeVariant5Fill,
    'soft-10': ShapeSoftEdgeVariant10Fill,
    'soft-25': ShapeSoftEdgeVariant25Fill,
    'soft-50': ShapeSoftEdgeVariant50Fill,
};

